export enum OrderStatusEnum {
  CREATED = 'created',
  SENT= 'sent',
  READY_TO_MAKE = 'ready to make',
  IN_MAKING = 'in making',
  IN_PREPARATION = 'in preparation',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELED = 'canceled',
}
